import { render } from "./HeaderNav.vue?vue&type=template&id=b37fb894&scoped=true"
import script from "./HeaderNav.vue?vue&type=script&lang=js"
export * from "./HeaderNav.vue?vue&type=script&lang=js"

import "./HeaderNav.vue?vue&type=style&index=0&id=b37fb894&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b37fb894"

export default script